import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="notfound-page">
      <div className="font-display text-8xl text-gold-700-gradient">404</div>
      <h1 className="font-display text-3xl text-ink-900 mt-4">Cette page a fait l'école buissonnière</h1>
      <p className="text-muted2 mt-3">Ce que vous cherchez n'existe pas (encore).</p>
      <Link to="/" className="inline-block mt-6 px-6 py-3 rounded-full bg-gold-500 text-ink-900 font-medium hover:bg-gold-500-400">
        Retour à l'accueil
      </Link>
    </div>
  );
}
